import { useFormikContext } from 'formik';
import React from 'react';
import styled from 'styled-components/macro';
import { CustomReportModalFormikValues } from '../types';
import { timeRangeConstants } from '../const';
import { FREQUENCY_DETAIL, FREQUENCY_TYPE } from './constants';
import { useTranslation } from 'react-i18next';
import { SegmentedControl } from 'lib/components/SegmentedControl';

const Title = styled.h3`
font-size: 12px;
font-weight: 600;
line-height: 24px;
text-align: left;
color:${({ theme }) => theme.colors.neutral[80]}
margin-bottom:16px;

`;

interface IProps {
  setFrequencyType: React.Dispatch<React.SetStateAction<FREQUENCY_TYPE>>;
  frequencyType: FREQUENCY_TYPE;
  updateRangeValue: (rangeValue: string) => void;
}
export const SelectFrequency = ({
  setFrequencyType,
  frequencyType,
  updateRangeValue,
}: IProps) => {
  const { setFieldValue } = useFormikContext<CustomReportModalFormikValues>();
  const { t } = useTranslation();

  const onChangeHandler = (newTab: FREQUENCY_TYPE) => {
    setFrequencyType(newTab);
    if (newTab === FREQUENCY_TYPE.DAILY) {
      setFieldValue(
        'recurrings.frequency',
        `${FREQUENCY_TYPE.DAILY};${FREQUENCY_DETAIL.EVERYDAY}`
      );
      updateRangeValue(timeRangeConstants.TODAY);
    }
    if (newTab === FREQUENCY_TYPE.WEEKLY) {
      setFieldValue('recurrings.frequency', `${FREQUENCY_TYPE.WEEKLY};`);
      updateRangeValue(timeRangeConstants.LAST_WEEK);
    }
    if (newTab === FREQUENCY_TYPE.MONTHLY) {
      setFieldValue('recurrings.frequency', `${FREQUENCY_TYPE.MONTHLY};1`);
      updateRangeValue(timeRangeConstants.LAST_MONTH);
    }
  };

  return (
    <div>
      <Title>{t('Frequency')}</Title>
      <SegmentedControl
        initialValue={frequencyType}
        values={[
          { value: FREQUENCY_TYPE.DAILY, label: t('Daily') },
          { value: FREQUENCY_TYPE.WEEKLY, label: t('Weekly') },
          { value: FREQUENCY_TYPE.MONTHLY, label: t('Monthly') },
        ]}
        onChange={newTab => onChangeHandler(newTab as FREQUENCY_TYPE)}
      />
    </div>
  );
};
